import { useId } from "react"

import { SegmentedControl } from "./SegmentedControl"
import { ChevronDownIcon } from "../../shared/components"
import { useCursorData } from "../contexts/CursorDataContext"

export const MoreOptions = () => {
  const id = useId()
  const { options, changeOptions } = useCursorData()

  return (
    <details className="group collapse overflow-visible rounded-none">
      <summary className="collapse-title flex w-fit items-center gap-1.5 rounded-field px-3 py-1 text-sm font-bold text-muted-content hover:text-base-content focus-visible:outline-2 focus-visible:outline-primary/60">
        <ChevronDownIcon className="size-4 transition-transform group-open:rotate-180" />
        More options
      </summary>
      <div className="collapse-content flex flex-col gap-3 px-3 pt-2 group-open:pb-1">
        <div className="flex items-center justify-between gap-3">
          <div className="flex min-w-0 flex-col">
            <span id={`${id}-framing`} className="text-sm font-bold">
              Framing
            </span>
            <span id={`${id}-framing-hint`} className="text-xs text-muted-content">
              Fit keeps everything; Fill zooms in and crops
            </span>
          </div>
          <SegmentedControl
            labelId={`${id}-framing`}
            hintId={`${id}-framing-hint`}
            choices={[
              { value: "fit", label: "Fit" },
              { value: "fill", label: "Fill" },
            ]}
            value={options.framing}
            onChange={(framing) => changeOptions({ ...options, framing })}
          />
        </div>
        <div className="flex items-center justify-between gap-3">
          <div className="flex min-w-0 flex-col">
            <label htmlFor={`${id}-remove-background`} className="text-sm font-bold">
              Remove background
            </label>
            <span id={`${id}-remove-background-hint`} className="text-xs text-muted-content">
              Cuts out a solid color around the edges
            </span>
          </div>
          <input
            id={`${id}-remove-background`}
            type="checkbox"
            role="switch"
            aria-describedby={`${id}-remove-background-hint`}
            checked={options.removeBackground}
            onChange={(event) =>
              changeOptions({ ...options, removeBackground: event.currentTarget.checked })
            }
            className="toggle toggle-primary toggle-sm"
          />
        </div>
        <div className="flex items-center justify-between gap-3">
          <div className="flex min-w-0 flex-col">
            <label htmlFor={`${id}-trim`} className="text-sm font-bold">
              Trim empty edges
            </label>
            <span id={`${id}-trim-hint`} className="text-xs text-muted-content">
              Drop transparent padding so the art fills the frame
            </span>
          </div>
          <input
            id={`${id}-trim`}
            type="checkbox"
            role="switch"
            aria-describedby={`${id}-trim-hint`}
            checked={options.trim}
            onChange={(event) => changeOptions({ ...options, trim: event.currentTarget.checked })}
            className="toggle toggle-primary toggle-sm"
          />
        </div>
        <div className="flex items-center justify-between gap-3">
          <div className="flex min-w-0 flex-col">
            <label htmlFor={`${id}-flip`} className="text-sm font-bold">
              Flip horizontally
            </label>
            <span id={`${id}-flip-hint`} className="text-xs text-muted-content">
              For left-handed pointers
            </span>
          </div>
          <input
            id={`${id}-flip`}
            type="checkbox"
            role="switch"
            aria-describedby={`${id}-flip-hint`}
            checked={options.flip}
            onChange={(event) => changeOptions({ ...options, flip: event.currentTarget.checked })}
            className="toggle toggle-primary toggle-sm"
          />
        </div>
        <div className="flex items-center justify-between gap-3">
          <div className="flex min-w-0 flex-col">
            <span id={`${id}-resampling`} className="text-sm font-bold">
              Resampling
            </span>
            <span id={`${id}-resampling-hint`} className="text-xs text-muted-content">
              Crisp keeps pixel art sharp
            </span>
          </div>
          <SegmentedControl
            labelId={`${id}-resampling`}
            hintId={`${id}-resampling-hint`}
            choices={[
              { value: "auto", label: "Auto" },
              { value: "smooth", label: "Smooth" },
              { value: "crisp", label: "Crisp" },
            ]}
            value={options.resampling}
            onChange={(resampling) => changeOptions({ ...options, resampling })}
          />
        </div>
      </div>
    </details>
  )
}
